import React, { useState, useEffect } from "react"
import { router } from "@inertiajs/react"
import { useUsers } from "@/lib/contexts/user-context"
import { useToast } from "@/hooks/use-toast"
import { AuthenticatedLayout } from "@/components/layout/authenticated-layout"

export function AppLayout({ children }) {
  const [isMounted, setIsMounted] = useState(false)
  const pathname = window.location.pathname
  const { currentUser } = useUsers()
  const { toast } = useToast()

  // Prevent hydration errors
  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null
  }

  return <>{children}</>
}
